import useSWR from 'swr'

import { ProductData } from '@livechat/design-system-react-components'

import { config } from 'lib/config'

export function useOrganizationProducts() {
	const { data, isLoading, error } = useSWR<ProductData[]>(`${config.accountsURL}/v2/organizations/my/products`, {
		revalidateIfStale: false,
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
	})

	return {
		organizationProducts: data,
		areOrganizationProductsLoading: isLoading,
		organizationProductsError: error,
	}
}
